import React from 'react'

const SmallNav = ({ children }) => {
  return (
    <div className="smallnav-title">
      <span>{children}</span>
    </div>
  )
}

export default SmallNav
